import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { ArticlePage } from '@/features/articles/components';

function ArticleDetailRoute(): ReactNode {
  const { slug } = Route.useParams();
  return <ArticlePage slug={slug} />;
}

// No AuthGuard: articles are publicly readable when their accessMode
// allows it. The route layer's `requireReadable` returns 404 for any
// hidden article, so a guest hitting a draft slug sees the not-found
// state instead of being redirected to login.
export const Route = createFileRoute('/articles/$slug/')({
  component: ArticleDetailRoute,
});
